import { CheckboxButtonProps, Styled } from './';

export const Checkbox = ({
  label,
  checked,
  disabled = false,
  onChange,
  style,
  value,
  children,

  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
}: CheckboxButtonProps) => {
  return (
    <Styled.Label disabled={disabled} style={style}>
      <Styled.Input
        type="checkbox"
        id={label}
        name={label}
        defaultChecked={checked}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        value={value}
        marginTop={marginTop}
        marginRight={marginRight}
        marginBottom={marginBottom}
        marginLeft={marginLeft}
      />
      {label.length > 0 ? label : children}
    </Styled.Label>
  );
};

export default Checkbox;
